import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import config from 'config';
import {reset, verifyToken} from '../../services/user/api';
import {handleChange} from '../../utils/ComponentUtilFunctions';
import {Link} from 'react-router-dom';
import BlueButton from '../../components-new/buttons/BlueButton';
import SilverButton from '../../components-new/buttons/SilverButton';
import Input from "../../components-new/form/Input";

class ResetPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            disabled: false,
            password: '',
            confirmPassword: '',
        };
        this.handleChange = handleChange.bind(this);
    }

    componentDidMount() {
        const {match, addNotification} = this.props;
        const {params} = match;
        const {token} = params;

        verifyToken(token)
            .then(() => {
                addNotification('yourTokenIsValid', config.notificationLevels.success);
            })
            .catch(() => {
                addNotification('yourTokenIsInvalid', config.notificationLevels.error, {
                    autoDismiss: 0,
                });
                setTimeout(() => {
                    window.location.href = config.APP_HOST + '/login';
                }, 1000);
            });
    }

    handleInputChange = (field) => (event) => {
        const value = event.target.value;
        this.setState({[field]: value,});
    };

    reset = (event) => {
        event.preventDefault();
        const {confirmPassword, password} = this.state;

        const {addNotification, match} = this.props;
        const {params} = match;
        const {token} = params;

        this.setState({
            e: true,
        });

        reset({password, confirmPassword}, token)
            .then(() => {
                addNotification("passwordChanged", config.notificationLevels.success);
                setTimeout(() => {
                    window.location.href = config.APP_HOST + '/login'
                }, 1000);
            })
            .catch((e) => {
                this.setState({
                    disabled: false,
                });
                if (e.response && e.response.data === "") {
                    addNotification('somethingWentWrong', config.notificationLevels.error);
                } else {
                    addNotification(e.response.data, config.notificationLevels.error);
                }
            });
    };

    render() {
        const {password, confirmPassword} = this.state;

        return (
            <div>

                <h1 className="form-header">
                    Create a new password
                </h1>

                <div className="app-login-form">
                    <form className="auth-form" onSubmit={this.reset}>

                        <Input
                            type="password"
                            label="New password"
                            value={password}
                            onChange={this.handleInputChange('password')}
                            placeholder={'Password'}
                        />

                        <Input
                            type="password"
                            label="Confirm new password"
                            value={confirmPassword}
                            onChange={this.handleInputChange('confirmPassword')}
                            placeholder={'Confirm password'}
                        />

                        <BlueButton className="auth-submit-button" height={36} type="submit" children="Save"/>

                        <div className="auth-form-link">
                            <Link to="/login" className="auth-form-link-button">
                                <SilverButton asDiv variant="ghost" height={36}>
                                    Sign-In
                                </SilverButton>
                            </Link>
                        </div>

                    </form>
                </div>
            </div>
        );
    }
}

ResetPassword.propTypes = {
    match: PropTypes.object.isRequired,
    addNotification: PropTypes.func.isRequired,
};

export default withRouter(ResetPassword);



// WEBPACK FOOTER //
// ./src/scenes/auth/ResetPassword.jsx